import React from "react";
import './Playlist.css';
import { MusicNote } from "@mui/icons-material";


export function playlistList(items: any[]) {
    if(items.length === 0) {
        return <div className="Login-prompt">
            Log in to see your playlists!
            <br/>
            <p className="Disclaimer">Currently in beta testing; you'll be able to see a beta user's annotated playlists publically, but unless you have been added as a user, you won't be able to log in.</p>
        </div>
    }
    const listItems = items.map((playlist: { id: React.Key | null | undefined; images: { url: string | undefined; }[]; name: string | number | bigint | boolean | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | Promise<string | number | bigint | boolean | React.ReactPortal | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined> | null | undefined; owner: { display_name: string | number | bigint | boolean | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | Promise<string | number | bigint | boolean | React.ReactPortal | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined> | null | undefined; }; collaborative: any; external_urls: { spotify: string | undefined; }; }) =>
        <li key={playlist.id}>
            <div className="Playlist-item">
                <a className="Playlist-link" href={`playlist/${playlist.id}`}>
                    <div className="Artwork-container">
                    {(playlist.images !== null) ? <img
                        src={playlist.images[0].url}
                        className="Image-artwork"
                        alt="Playlist cover"
                    /> : <MusicNote/>}
                    </div>
                    <p>
                        <b>{playlist.name}</b> <br />
                        {playlist.owner.display_name} <br />
                        {/* collaborative: {playlist.collaborative ? "True" : "False"} */}
                    </p>
                </a>
                <a href={playlist.external_urls.spotify} className="Spotify-link" target="_blank" rel="noreferrer">View on Spotify</a>
            </div>
        </li>
    );

    return (
        <div>
            <ul className="Playlist-list">
                {listItems}
            </ul>
        </div>
    )
}